$(document).ready(function () {

  if ($('.modal').length == 0) {
    return;
  }

  if (getCookie('modal') === "") {
    displayModal();
    setCookie('modal', 1, 1);
  }

  $('.modal__close-icon').on('click', function () {
    closeModal();
  })

  $('.modal__overlay').on('click', function () {
    closeModal();
  })

  function displayModal() {
    $('.modal').css({
      visibility: 'visible',
      transition: 'display 2s ease-in-out'
    });
    $('.modal__overlay').css({
      visibility: 'visible',
      transition: 'display 2s ease-in-out'
    });
    window.document.body.style.overflowY = 'hidden';
  }

  function closeModal() {
    $('.modal').css({
      visibility: 'hidden',
      transition: 'display 2s ease-in-out'
    });
    $('.modal__overlay').css({
      visibility: 'hidden',
      transition: 'display 2s ease-in-out'
    });
    window.document.body.style.overflowY = 'scroll';
  }

  function setCookie(cname, cvalue, days) {
    const d = new Date();
    d.setTime(d.getTime() + (days * 24 * 60 * 60 * 1000));
    let expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }

  function getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }
  
})  